import React, { ReactNode, useEffect, useState } from "react";
import { Menu, IconButton } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import useTableStore from "../stores/TableStore";

interface MenuBoxProps {
    children?: ReactNode;
}

const MenuBox: React.FC<MenuBoxProps> = ({
    children,
}) => {
    const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
    const { showMenu, setShowMenu, continuousMenu } = useTableStore();

    useEffect(() => {
        if (showMenu) {
            const btn = document.getElementById('iconBtn') as HTMLButtonElement;
            if (btn && continuousMenu) {
                btn.click();
            }
        }
    }, []);

    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setMenuAnchor(event.currentTarget);
        setShowMenu(true);
    };

    const handleMenuClose = () => {
        setMenuAnchor(null);
        setShowMenu(false);
    };

    return (
        <>
            <IconButton id="iconBtn" onClick={handleMenuOpen}>
                <MoreHorizIcon />
            </IconButton>
            <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={handleMenuClose}
                keepMounted
                classes={{
                    paper: "background-gray", // 绑定自定义样式类
                }}
            >
                {children}
            </Menu>
        </>
    );
};

export default MenuBox;
